export const numberStr = [
    '第一签',
    '第二签',
    '第三签',
    '第四签',
    '第五签',
    '第六签',
    '第七签',
    '第八签',
    '第九签',
    '第一十签',
    '第一十一签',
    '第一十二签',
    '第一十三签',
    '第一十四签',
    '第一十五签',
    '第一十六签',
    '第一十七签',
    '第一十八签',
    '第一十九签',
    '第二十签',
    '第二十一签',
    '第二十二签',
    '第二十三签',
    '第二十四签',
    '第二十五签',
    '第二十六签',
    '第二十七签',
    '第二十八签',
    '第二十九签',
    '第三十签',
    '第三十一签',
    '第三十二签',
    '第三十三签',
    '第三十四签',
    '第三十五签',
    '第三十六签',
    '第三十七签',
    '第三十八签',
    '第三十九签',
    '第四十签',
    '第四十一签',
    '第四十二签',
    '第四十三签',
    '第四十四签',
    '第四十五签',
    '第四十六签',
    '第四十七签',
    '第四十八签',
    '第四十九签',
    '第五十签',
    '第五十一签',
    '第五十二签',
    '第五十三签',
    '第五十四签',
    '第五十五签',
    '第五十六签',
    '第五十七签',
    '第五十八签',
    '第五十九签',
    '第六十签',
    '第六十一签',
    '第六十二签',
    '第六十三签',
    '第六十四签',
    '第六十五签',
    '第六十六签',
    '第六十七签',
    '第六十八签',
    '第六十九签',
    '第七十签',
    '第七十一签',
    '第七十二签',
    '第七十三签',
    '第七十四签',
    '第七十五签',
    '第七十六签',
    '第七十七签',
    '第七十八签',
    '第七十九签',
    '第八十签',
    '第八十一签',
    '第八十二签',
    '第八十三签',
    '第八十四签',
    '第八十五签',
    '第八十六签',
    '第八十七签',
    '第八十八签',
    '第八十九签',
    '第九十签',
    '第九十一签',
    '第九十二签',
    '第九十三签',
    '第九十四签',
    '第九十五签',
    '第九十六签',
    '第九十七签',
    '第九十八签',
    '第九十九签',
    '第一百签',
]

export const data0 = [
    { id: 1, '吉凶': '上上' },
    { id: 2, '吉凶': '上吉' },
    { id: 3, '吉凶': '大吉' },
    { id: 4, '吉凶': '中吉' },
    { id: 5, '吉凶': '中平' },
    { id: 6, '吉凶': '中下' },
    { id: 7, '吉凶': '下吉' },
    { id: 8, '吉凶': '下平' },
    { id: 9, '吉凶': '下下' },
]

//大显殿灵签
//上上:10;上吉:15;大吉:3;
//中吉:7;中平:35;中下:1;
//下吉:0;下平:0;下下:29;
export const data1 = [
    { '签号': '第一百签', '故事': '唐明皇祷告天', '签文': '癸癸', '吉凶': '上上' },
    { '签号': '第九十九签', '故事': '百里奚投秦', '签文': '癸癸', '吉凶': '上上' },
    { '签号': '第九十八签', '故事': '薛仁贵投军', '签文': '癸辛', '吉凶': '中平' },
    { '签号': '第九十七签', '故事': '买臣五十富贵', '签文': '癸庚', '吉凶': '上上' },
    { '签号': '第九十六签', '故事': '山涛见王衍', '签文': '癸己', '吉凶': '上吉' },
    { '签号': '第九十五签', '故事': '张文远求官', '签文': '癸戊', '吉凶': '中平' },
    { '签号': '第九十四签', '故事': '提结过长者门', '签文': '癸丁', '吉凶': '中平' },
    { '签号': '第九十三签', '故事': '邵康节定阴阳', '签文': '癸丙', '吉凶': '中平' },
    { '签号': '第九十二签', '故事': '高祖治汉民', '签文': '癸乙', '吉凶': '下下' },
    { '签号': '第九十一签', '故事': '赵子龙抱太子', '签文': '癸甲', '吉凶': '中平' },
    { '签号': '第九十签', '故事': '杨文广陷柳州', '签文': '壬癸', '吉凶': '中平' },
    { '签号': '第八十九签', '故事': '班超归玉门关', '签文': '壬壬', '吉凶': '中平' },
    { '签号': '第八十八签', '故事': '高文定守困', '签文': '壬辛', '吉凶': '上吉' },
    { '签号': '第八十七签', '故事': '武侯与子敬同舟', '签文': '壬庚', '吉凶': '下下' },
    { '签号': '第八十六签', '故事': '管鲍为贾', '签文': '壬己', '吉凶': '上上' },
    { '签号': '第八十五签', '故事': '姜女寻夫', '签文': '壬戊', '吉凶': '中平' },
    { '签号': '第八十四签', '故事': '须贾害范睢', '签文': '壬丁', '吉凶': '中平' },
    { '签号': '第八十三签', '故事': '诸葛孔明学道', '签文': '壬丙', '吉凶': '下下' },
    { '签号': '第八十二签', '故事': '宋仁宗认母', '签文': '壬乙', '吉凶': '上吉' },
    { '签号': '第八十一签', '故事': '寇公任雷阳', '签文': '壬甲', '吉凶': '中平' },
    { '签号': '第八十签', '故事': '郭璞为母卜葬', '签文': '辛癸', '吉凶': '下下' },
    { '签号': '第七十九签', '故事': '文王编易卦', '签文': '辛壬', '吉凶': '中平' },
    { '签号': '第七十八签', '故事': '袁安守困', '签文': '辛辛', '吉凶': '下下' },
    { '签号': '第七十七签', '故事': '吕后害韩信', '签文': '辛庚', '吉凶': '下下' },
    { '签号': '第七十六签', '故事': '萧何注律', '签文': '辛巳', '吉凶': '中平' },
    { '签号': '第七十五签', '故事': '刘小姐爱蒙正', '签文': '辛戊', '吉凶': '上吉' },
    { '签号': '第七十四签', '故事': '崔武求官', '签文': '辛丁', '吉凶': '上吉' },
    { '签号': '第七十三签', '故事': '王昭君忆汉帝', '签文': '辛丙', '吉凶': '下下' },
    { '签号': '第七十二签', '故事': '范蠡归湖', '签文': '辛乙', '吉凶': '下下' },
    { '签号': '第七十一签', '故事': '苏武还乡', '签文': '辛甲', '吉凶': '中平' },
    { '签号': '第七十签', '故事': '王曾祈祷', '签文': '庚癸', '吉凶': '中平' },
    { '签号': '第六十九签', '故事': '孙庞斗智', '签文': '庚壬', '吉凶': '下下' },
    { '签号': '第六十八签', '故事': '钱大王贩盐', '签文': '庚辛', '吉凶': '中平' },
    { '签号': '第六十七签', '故事': '江遗嘱儿', '签文': '庚庚', '吉凶': '中平' },
    { '签号': '第六十六签', '故事': '杜甫游春', '签文': '庚己', '吉凶': '上上' },
    { '签号': '第六十五签', '故事': '蒙正木兰和诗', '签文': '庚戊', '吉凶': '上上' },
    { '签号': '第六十四签', '故事': '管鲍分金', '签文': '庚丁', '吉凶': '上上' },
    { '签号': '第六十三签', '故事': '杨令公撞李陵碑', '签文': '庚丙', '吉凶': '中平' },
    { '签号': '第六十二签', '故事': '韩信占霸王', '签文': '庚乙', '吉凶': '中平' },
    { '签号': '第六十一签', '故事': '蒯辄见韩信', '签文': '庚甲', '吉凶': '中平' },
    { '签号': '第六十签', '故事': '宋郊兄弟同科', '签文': '己癸', '吉凶': '上上' },
    { '签号': '第五十九签', '故事': '邓伯道无儿', '签文': '己壬', '吉凶': '中平' },
    { '签号': '第五十八签', '故事': '苏秦背剑', '签文': '己辛', '吉凶': '上吉' },
    { '签号': '第五十七签', '故事': '烂柯观棋', '签文': '己庚', '吉凶': '中平' },
    { '签号': '第五十六签', '故事': '五枢密奸险', '签文': '己巳', '吉凶': '下下' },
    { '签号': '第五十五签', '故事': '包龙图劝农', '签文': '己戊', '吉凶': '中平' },
    { '签号': '第五十四签', '故事': '苏秦刺股', '签文': '己丁', '吉凶': '中平' },
    { '签号': '第五十三签', '故事': '刘先主入赘孙权妹', '签文': '己丙', '吉凶': '下下' },
    { '签号': '第五十二签', '故事': '匡衡夜读书', '签文': '己乙', '吉凶': '上吉' },
    { '签号': '第五十一签', '故事': '御沟流红叶', '签文': '己甲', '吉凶': '上吉' },
    { '签号': '第五十签', '故事': '苏东坡功民', '签文': '戊癸', '吉凶': '上吉' },
    { '签号': '第四十九签', '故事': '张子房遁迹', '签文': '戊壬', '吉凶': '下下' },
    { '签号': '第四十八签', '故事': '赵五娘寻夫', '签文': '戊辛', '吉凶': '中平' },
    { '签号': '第四十七签', '故事': '楚汉争锋', '签文': '戊庚', '吉凶': '下下' },
    { '签号': '第四十六签', '故事': '孤儿报冤', '签文': '戊己', '吉凶': '中平' },
    {
        '签号': '第四十五签',
        '故事': '高祖遇丁公',
        '签文': '戊戊',
        '吉凶': '中平'
    },
    {
        '签号': '第四十四签',
        '故事': '王莽篡位',
        '签文': '戊丁',
        '吉凶': '中平'
    },
    {
        '签号': '第四十三签',
        '故事': '玄德公黄鹤楼赴宴',
        '签文': '戊丙',
        '吉凶': '中吉'
    },
    {
        '签号': '第四十二签',
        '故事': '董永卖身',
        '签文': '戊乙',
        '吉凶': '中吉'
    },
    {
        '签号': '第四十一签',
        '故事': '刘文龙求官',
        '签文': '戊申',
        '吉凶': '中吉'
    },
    {
        '签号': '第四十签',
        '故事': '汉光武陷昆明',
        '签文': '丁癸',
        '吉凶': '上吉'
    },
    {
        '签号': '第三十九签',
        '故事': '陶渊明赏菊',
        '签文': '丁壬',
        '吉凶': '下下'
    },
    {
        '签号': '第三十八签',
        '故事': '孟姜女思夫',
        '签文': '丁辛',
        '吉凶': '下下'
    },
    {
        '签号': '第三十七签',
        '故事': '邵尧夫祝香',
        '签文': '丁庚',
        '吉凶': '中平'
    },
    {
        '签号': '第三十六签',
        '故事': '罗隐求官',
        '签文': '丁己',
        '吉凶': '上吉'
    },
    {
        '签号': '第三十五签',
        '故事': '王昭君和番',
        '签文': '丁戊',
        '吉凶': '下下'
    },
    {
        '签号': '第三十四签',
        '故事': '萧何追韩信',
        '签文': '丁丁',
        '吉凶': '中平'
    },
    {
        '签号': '第三十三签',
        '故事': '庄子慕道',
        '签文': '丁丙',
        '吉凶': '中平'
    },
    {
        '签号': '第三十二签',
        '故事': '周公解梦',
        '签文': '丁乙',
        '吉凶': '下下'
    },
    {
        '签号': '第三十一签',
        '故事': '苏卿负信',
        '签文': '丁甲',
        '吉凶': '中吉'
    },
    {
        '签号': '第三十签',
        '故事': '柳毅传书',
        '签文': '丙癸',
        '吉凶': '中吉'
    },
    {
        '签号': '第二十九签',
        '故事': '司马温公嗟困',
        '签文': '丙壬',
        '吉凶': '上上'
    },
    {
        '签号': '第二十八签',
        '故事': '相如题桥',
        '签文': '丙辛',
        '吉凶': '上吉'
    },
    {
        '签号': '第二十七签',
        '故事': '江东得道',
        '签文': '丙庚',
        '吉凶': '下下'
    },
    {
        '签号': '第二十六签',
        '故事': '邵尧夫告天',
        '签文': '丙己',
        '吉凶': '中吉'
    },
    {
        '签号': '第二十五签',
        '故事': '唐明皇游月宫',
        '签文': '丙戊',
        '吉凶': '中平'
    },
    {
        '签号': '第二十四签',
        '故事': '张骞误入斗牛宫',
        '签文': '丙丁',
        '吉凶': '中平'
    },
    {
        '签号': '第二十三签',
        '故事': '吴王爱西施',
        '签文': '丙丙',
        '吉凶': '下下'
    },
    {
        '签号': '第二十二签',
        '故事': '李太白遇唐明皇',
        '签文': '丙乙',
        '吉凶': '上吉'
    },
    {
        '签号': '第二十一签',
        '故事': '孙庞斗智结仇',
        '签文': '丙甲',
        '吉凶': '下下'
    },
    {
        '签号': '第二十签',
        '故事': '严子陵登钓台',
        '签文': '乙癸',
        '吉凶': '下下'
    },
    {
        '签号': '第十九签',
        '故事': '刘智远得岳氏',
        '签文': '乙壬',
        '吉凶': '上吉'
    },
    {
        '签号': '第十八签',
        '故事': '孟尝君招贤',
        '签文': '乙辛',
        '吉凶': '中平'
    },
    {
        '签号': '第十七签',
        '故事': '石崇被难',
        '签文': '乙庚',
        '吉凶': '下下'
    },
    {
        '签号': '第十六签',
        '故事': '王祥卧冰',
        '签文': '乙己',
        '吉凶': '下下'
    },
    {
        '签号': '第十五签',
        '故事': '张君瑞忆莺莺',
        '签文': '乙戊',
        '吉凶': '中平'
    },
    {
        '签号': '第十四签',
        '故事': '郭华恋王月英',
        '签文': '乙丁',
        '吉凶': '下下'
    },
    {
        '签号': '第十三签',
        '故事': '姜太公钓鱼',
        '签文': '乙丙',
        '吉凶': '中下'
    },
    {
        '签号': '第十二签',
        '故事': '苏武牧羊',
        '签文': '乙乙',
        '吉凶': '下下'
    },
    {
        '签号': '第十一签',
        '故事': '韩信功劳不久',
        '签文': '乙甲',
        '吉凶': '下下'
    },
    {
        '签号': '第十签',
        '故事': '冉伯牛染疾',
        '签文': '甲癸',
        '吉凶': '下下'
    },
    {
        '签号': '第九签',
        '故事': '宋太祖陈桥即位',
        '签文': '甲壬',
        '吉凶': '大吉'
    },
    {
        '签号': '第八签',
        '故事': '大舜耕历山',
        '签文': '甲辛',
        '吉凶': '上上'
    },
    {
        '签号': '第七签',
        '故事': '洞宾练丹',
        '签文': '甲庚',
        '吉凶': '大吉'
    },
    {
        '签号': '第六签',
        '故事': '相如完璧归赵',
        '签文': '甲己',
        '吉凶': '下下'
    },
    {
        '签号': '第五签',
        '故事': '吕蒙正守困',
        '签文': '甲戊',
        '吉凶': '中平'
    },
    {
        '签号': '第四签',
        '故事': '小秦王三跳涧',
        '签文': '甲丁',
        '吉凶': '下下'
    },
    {
        '签号': '第三签',
        '故事': '贾谊遇汉文帝',
        '签文': '甲丙',
        '吉凶': '中吉'
    },
    {
        '签号': '第二签',
        '故事': '张子房游赤松',
        '签文': '甲乙',
        '吉凶': '上吉'
    },
    {
        '签号': '第一签',
        '故事': '汉高祖入关',
        '签文': '甲甲',
        '吉凶': '大吉'
    }
]

//观音灵签
export const data2 = [
    {
        '签数': 1,
        '签名': '钟离成道',
        '吉凶': '上签',
        '宫位': '子宫',
        '签文': [
            '天开地辟结良缘，日吉时良万事全。',
            '若得此签非小可，人行中正帝王宣。'
        ],
        '签意': '此卦盘古初开天地之象，诸事皆吉。',
        '签解': '急速兆速。年未值时。观音降笔。先报君知。'
    },
    {
        '签数': 2,
        '签名': '苏秦不第',
        '吉凶': '下签',
        '宫位': '子宫',
        '签文': [
            '鲸鱼未变守江河，不可升腾更望高。',
            '异日峥嵘身变化，许君一跃跳龙门。'
        ],
        '签意': '时机未到，需耐心等待，不可强求。',
        '签解': '得忍且忍。得耐且耐。须待时至。功名还在。'
    },
    {
        '签数': 3,
        '签名': '董永遇仙',
        '吉凶': '下签',
        '宫位': '子宫',
        '签文': [
            '临风冒雨去还乡，正是其身似燕儿。',
            '衔得坭来欲作垒，到头垒坏复须坭。'
        ],
        '签意': '此卦燕子衔坭之象。凡事劳心费力也。',
        '签解': '千般用计。晨昏不停。谁知此事。到底劳心。'
    },
    {
        '签数': 4,
        '签名': '玉莲会十朋',
        '吉凶': '上签',
        '宫位': '子宫',
        '签文': [
            '千年古镜复重圆，女再求夫男再婚。',
            '自此门庭重改换，更添福禄在儿孙。'
        ],
        '签意': '此卦古镜重圆之象。凡事劳心有贵也。',
        '签解': '淘沙见金。骑龙踏虎。虽是劳心。于中有补。'
    },
    {
        '签数': 5,
        '签名': '刘晨遇仙',
        '吉凶': '中签',
        '宫位': '丑宫',
        '签文': [
            '一锥草地要求泉，努力求之得最难。',
            '无意俄然遇知己，相逢携手上青天。'
        ],
        '签意': '此卦锥地求泉之象。凡事先难后易也。',
        '签解': '欲望心事。西方可求。不如莫动。立地可谋。'
    },
    {
        '签数': 6,
        '签名': '仁贵遇主',
        '吉凶': '中签',
        '宫位': '丑宫',
        '签文': [
            '投身岩下铜鸟居，须是还他大丈夫。',
            '拾得营谋谁可知，通行天地此人无。'
        ],
        '签意': '此卦投岩铜鸟之象。凡事宜顺吉之兆。',
        '签解': '食用无余。身清喜贫。待时利乐。权与概人。',
    },
    {
        '签数': 7,
        '签名': '苏娘走难',
        '吉凶': '下签',
        '宫位': '丑宫',
        '签文': [
            '奔波阻隔重重险，带水拖泥去度山。',
            '更望他乡求用事，千乡万里未回还。'
        ],
        '签意': '此卦拖坭带水之象。凡事守旧则吉也。',
        '签解': '退身可得。进步为难。只宜守旧。莫望高扳。',
    },
    {
        '签数': 8,
        '签名': '姚能遇仙',
        '吉凶': '上签',
        '宫位': '丑宫',
        '签文': [
            '茂林松柏正兴旺，雨雪风霜总莫为。',
            '异日忽然成大用，功名成就栋梁材。'
        ],
        '签意': '此卦此卦松柏茂林之象。凡事有贵气也。',
        '签解': '路上亨通。终身有功。田蚕丰熟。家道兴隆。'
    },
    {
        '签数': 9,
        '签名': '孔明点将',
        '吉凶': '上签',
        '宫位': '寅宫',
        '签文': [
            '烦君勿作私心事，此意偏宜说问公。',
            '一片明心光皎洁，宛如皎月正天心。'
        ],
        '签意': '此卦皎月当空之象，凡事光明通气也。',
        '签解': '心中正直，理顺法宽，终有分明。'
    },
    {
        '签数': 10,
        '签名': '庞涓观阵',
        '吉凶': '中签',
        '宫位': '寅宫',
        '签文': [
            '石藏无价玉和珍，只管他乡外客寻。',
            '宛如持灯更觅火，不如收拾枉劳心。'
        ],
        '签意': '此卦持灯觅火之象。凡事待时成就也。',
        '签解': '姻缘会遇。何事不成。须无限意。眼前是真。'
    },
    {
        '签数': 11,
        '签名': '书荐姜维',
        '吉凶': '上签',
        '宫位': '寅宫',
        '签文': [
            '欲求胜事可非常，争奈亲姻日暂忙。',
            '到头竟必成鹿箭，贵人指引贵人乡。'
        ],
        '签意': '此卦因祸得福之象。凡事营谋吉利也。',
        '签解': '有意兴变。到底安然。若问用事。只近贵人。'
    },
    {
        '签数': 12,
        '签名': '武吉遇师',
        '吉凶': '上签',
        '宫位': '寅宫',
        '签文': [
            '否去泰来咫尺间，暂交君子出于山。',
            '若逢虎兔佳音信，立志忙中事即闲。'
        ],
        '签意': '此卦祸中有福之象。凡事先凶后吉也。',
        '签解': '换麻得丝。击人双足。要见分明。因灾得福。'
    },
    {
        '签数': 13,
        '签名': '罗通拜帅',
        '吉凶': '中签',
        '宫位': '寅宫',
        '签文': [
            '自小生在富贵家，眼前万物总奢华。',
            '蒙君赐紫金玉带，四海声名定可夸。'
        ],
        '签意': '此卦龙门得遇之象。凡事有变大吉也。',
        '签解': '囚人逢赦。病即安然。龙门得遇。名遍皇都。'
    },
    {
        '签数': 14,
        '签名': '子牙弃官',
        '吉凶': '中签',
        '宫位': '卯宫',
        '签文': [
            '宛如仙鹤出樊笼，脱得樊笼路路通。',
            '南北东西无阻隔，任君直上九霄宫。'
        ],
        '签意': '此卦仙鹤离笼之象。凡事先凶后吉也。',
        '签解': '任意无虑。路有亨通。随心所欲。逍遥如人。'
    },
    {
        '签数': 15,
        '签名': '苏秦得志',
        '吉凶': '中签',
        '宫位': '卯宫',
        '签文': [
            '行人怨日气难吞，忽有灾事勿近前。',
            '鸟破林巢无所宿，可寻深处稳安身。'
        ],
        '签意': '此卦鸟鹊离林之象。凡事到底应心也。',
        '签解': '若人和怨。何时可伸。好言不信。守旧待时。'
    },
    {
        '签数': 16,
        '签名': '叶梦熊朝帝',
        '吉凶': '中签',
        '宫位': '卯宫',
        '签文': [
            '愁眉思虑暂时开，启出云霄喜自来。',
            '宛如粪土中藏玉，良工荐举出尘埃。'
        ],
        '签意': '此卦阴阳和合之象。凡所谋皆吉也。',
        '签解': '得处无失。损中有益。小人逢凶。君子顺吉。'
    },
    {
        '签数': 17,
        '签名': '曹操话梅止渴',
        '吉凶': '中签',
        '宫位': '卯宫',
        '签文': [
            '莫听闲言说是非，晨昏只好念弥陀。',
            '若将狂话为真实，画饼如何止得饥。'
        ],
        '签意': '此卦画饼充饥之象。诸事多虚少实也。',
        '签解': '心中不定。枉看经文。恰似画饼。食也难吞。'
    },
    {
        '签数': 18,
        '签名': '曹国舅为仙',
        '吉凶': '上签',
        '宫位': '卯宫',
        '签文': [
            '金乌西坠兔东升，日夜循环至古今。',
            '僧道得知无不利，士农工商各从心。'
        ],
        '签意': '此卦阴阳消长之象。凡事遂意之兆也。',
        '签解': '心中无事。所作有功。如弓上箭。一发当空。'
    },
    {
        '签数': 19,
        '签名': '子仪封王',
        '吉凶': '中签',
        '宫位': '辰宫',
        '签文': [
            '急水滩头放船归，风波作浪欲何为。',
            '若要安然求稳静，等待浪静道此危。'
        ],
        '签意': '此卦船行急滩之象。凡事守旧待时也。',
        '签解': '急水下船。险处待时。若问营谋。尽可施为。'
    },
    {
        '签数': 20,
        '签名': '姜太公遇文王',
        '吉凶': '中签',
        '宫位': '辰宫',
        '签文': [
            '当春久雨喜开晴，玉兔金乌渐渐明。',
            '旧事消散新事遂，看看一跳过龙门。'
        ],
        '签意': '此卦久雨初明之象。凡事遂意也。',
        '签解': '神佛护持。有灾无危。途生平安。到底荣归。'
    },
    {
        '签数': 21,
        '签名': '李旦龙凤配合',
        '吉凶': '上签',
        '宫位': '辰宫',
        '签文': [
            '阴阳道合总由天，女嫁男婚喜偎然。',
            '但见龙蛇相会合，熏熏入梦喜团圆。'
        ],
        '签意': '此卦阴阳道合之象。凡事和合大吉也。',
        '签解': '谋望从心。婚姻孕男。资财进益。更利田蚕。'
    },
    {
        '签数': 22,
        '签名': '六郎逢救',
        '吉凶': '中签',
        '宫位': '已宫',
        '签文': [
            '旱时田里皆枯藁，谢天甘雨落淋淋。',
            '花果草木皆润泽，始知一雨值千金。'
        ],
        '签意': '此卦旱逢甘雨之象。凡事难中有救也。',
        '签解': '田蚕倍熟。命运渐来。病遇良药。行人便回。'
    },
    {
        '签数': 23,
        '签名': '怀德招亲',
        '吉凶': '中签',
        '宫位': '巳宫',
        '签文': [
            '欲扳仙桂入蟾宫，岂虑天门不任君。',
            '忽遇一般音信好，人人欢笑领顶花。'
        ],
        '签意': '此卦手扳仙桂之象。凡事必有贵人也。',
        '签解': '商贾利益。行藏有危。病安讼遂。尽可施为。'
    },
    {
        '签数': 24,
        '签名': '殷郊遇师',
        '吉凶': '下签',
        '宫位': '巳宫',
        '签文': [
            '不成理论不成家，水性痴人似落花。',
            '若问君恩须得力，到头方见事如麻。'
        ],
        '签意': '此卦痴人道塞之象。凡事守旧待时也。',
        '签解': '是非莫说。必须仔细。心正理直。方免灾危。'
    },
    {
        '签数': 25,
        '签名': '李广机智',
        '吉凶': '中平签',
        '宫位': '巳宫',
        '签文': [
            '过了忧危事几重，从今再立永无空。',
            '宽心自有宽心计，得遇高人立大功。'
        ],
        '签意': '此卦古井逢泉之象。凡事贵人成就也。',
        '签解': '讼终有理。病得安全。出入求谋。古井逢泉。'
    },
    {
        '签数': 26,
        '签名': '钟馗得道',
        '吉凶': '中签',
        '宫位': '巳宫',
        '签文': [
            '上下传来事转虚，天边接得一封书。',
            '书中许我功名遂，直到终时亦是虚。'
        ],
        '签意': '此卦虚名之象。凡事虚多少实宜守旧也。',
        '签解': '上下心烦。求闲不闲。欲望功名。守旧得安。'
    },
    {
        '签数': 27,
        '签名': '刘基谏主',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '一谋一用一番书，虑后思前不敢为。',
            '时到贵人相助力，如山壁立可安居。'
        ],
        '签意': '此卦屋好墙壁之象。凡事稳当无险也。',
        '签解': '改旧成新。寒花遇春。从前阻滞。今得称心。'
    },
    {
        '签数': 28,
        '签名': '李后寻包公',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '东边月上正蝉娟，顷刻云遮亦暗存。',
            '或有圆时还有缺，更言非者亦闲言。'
        ],
        '签意': '此卦月被云遮之象。凡事昏迷未定也。',
        '签解': '浮云遮月。不须疑惑。等待云收。便见收获。'
    },
    {
        '签数': 29,
        '签名': '赵子龙救阿斗',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '宝剑出匣耀光明，在匣全然不惹尘。',
            '今得贵人携出现，有威有势众人钦。'
        ],
        '签意': '此卦宝剑出匣之象。凡事有威有势也。',
        '签解': '宝剑出匣。光辉万里。贵人指引。无不观美。'
    },
    {
        '签数': 30,
        '签名': '棋盘大会',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '劝君切莫向他求，似鹤飞来暗箭投。',
            '若去采薪蛇在草，恐遭毒口也忧愁。'
        ],
        '签意': '此卦安份守己之象。凡事小心谨防也。',
        '签解': '闭口合齿。他事莫理。若有亏心。到头害己。'
    },
    {
        '签数': 31,
        '签名': '佛印会东坡',
        '吉凶': '中签',
        '宫位': '未宫',
        '签文': [
            '清闲无忧静处坐，饱后喝茶时坐卧。',
            '放下身心不用忙，必定不招冤与祸。'
        ],
        '签意': '此卦守旧安然之象。凡事时待时则吉也。',
        '签解': '守旧安然。叩问神仙。直待时来。事亦偶然。'
    },
    {
        '签数': 32,
        '签名': '刘备求贤',
        '吉凶': '中签',
        '宫位': '未宫',
        '签文': [
            '前程杳杳定无疑，石中藏玉有谁知。',
            '一朝良匠分明剖，始觉安然碧玉期。'
        ],
        '签意': '此卦剖石见玉之象。凡事着力成功也。',
        '签解': '宝在石中。异人少知。直待分明。尽可施为。'
    },
    {
        '签数': 33,
        '签名': '咬金聘仁贵',
        '吉凶': '中签',
        '宫位': '未宫',
        '签文': [
            '内藏无价宝和珍，得玉何须外界寻。',
            '不如等待高人识，宽心犹且更宽心。'
        ],
        '签意': '此卦藏玉外觅之象。凡事待时可也。',
        '签解': '内藏金玉。何必外寻。遇贵指引。不须劳心。'
    },
    {
        '签数': 34,
        '签名': '桃园结义',
        '吉凶': '中签',
        '宫位': '未宫',
        '签文': [
            '行藏出入礼义恭，言必忠良信必聪。',
            '心不了然且静澈，光明红日正当中。'
        ],
        '签意': '此卦红日当空正照之象。凡事遂意也。',
        '签解': '心中无事。秋水澄清。不须疑惑。事自然成。'
    },
    {
        '签数': 35,
        '签名': '唐僧取经',
        '吉凶': '中签',
        '宫位': '申宫',
        '签文': [
            '衣冠重整旧家风，道是无穹却有功。',
            '扫却当途荆棘刺，三人约议再和同。'
        ],
        '签意': '此卦衣冠重整之象。凡事先难后易也。',
        '签解': '不用忧疑。自有佳期。若问前程。前路可宜。'
    },
    {
        '签数': 36,
        '签名': '湘子遇宾',
        '吉凶': '中签',
        '宫位': '申宫',
        '签文': [
            '眼前病讼不须忧，满地资财尽可求。',
            '恰似猿猴金锁脱，自归山洞去来游。'
        ],
        '签意': '此卦猿猴脱锁之象。凡事先难后易也。',
        '签解': '脱除了事。且自宽心。待得时来。堪寻正路。'
    },
    {
        '签数': 37,
        '签名': '李靖归山',
        '吉凶': '中签',
        '宫位': '申宫',
        '签文': [
            '欲待身安运泰时，风中灯烛不相宜。',
            '不如收拾深堂坐，庶免光摇静处明。'
        ],
        '签意': '此卦风摇灯烛之象。凡事守常则吉也。',
        '签解': '静处安身。待命守时。动惹非福。守旧无疑。'
    },
    {
        '签数': 38,
        '签名': '何文秀遇难',
        '吉凶': '下签',
        '宫位': '申宫',
        '签文': [
            '月照天宅静处期，忽遭云雾又昏迷。',
            '宽心祈待云霞散，此时更改好施为。'
        ],
        '签意': '此卦云雾遮月之象，凡事未遂，守旧待时。',
        '签解': '家道忧凶。人口有灾。祈福保庆。犹恐破财。'
    },
    {
        '签数': 39,
        '签名': '姜女寻夫',
        '吉凶': '下签',
        '宫位': '酉宫',
        '签文': [
            '天边消息实难思，切莫多心望强求。',
            '若把石头磨作镜，曾知枉费己工夫。'
        ],
        '签意': '此卦守常安静之象。凡事守己则吉也。',
        '签解': '千般用计。枉费功夫。不如守旧。着甚来由。'
    },
    {
        '签数': 40,
        '签名': '武则天登位',
        '吉凶': '中签',
        '宫位': '酉宫',
        '签文': [
            '红轮西坠兔东升，阴长阳消百事亭。',
            '若是女人宜望用，增添财禄福其心。'
        ],
        '签意': '此卦阴长阳消之象。凡事先难后易也。',
        '签解': '阴利女人。不宜男子。若是求谋。先凶后吉。'
    },
    {
        '签数': 41,
        '签名': '董卓收吕布',
        '吉凶': '中签',
        '宫位': '酉宫',
        '签文': [
            '无限好言君记取，却为认贼将作子。',
            '莫贪眼下有些甜，更虑他年前样思。'
        ],
        '签意': '此卦认贼作子之象。凡事认真防假。',
        '签解': '只这一着。君子莫错。牢记在心。不生寂寞。'
    },
    {
        '签数': 42,
        '签名': '目莲救母',
        '吉凶': '上签',
        '宫位': '酉宫',
        '签文': [
            '君皇圣后总为恩，复待祈禳无损增。',
            '一切有情皆受用，人间天上得期亨。'
        ],
        '签意': '此卦天垂恩泽之象。凡事成就大吉也。',
        '签解': '天皇降恩。始终莫忘。晨昏礼佛。可宜烧香。'
    },
    {
        '签数': 43,
        '签名': '行者得道',
        '吉凶': '上签',
        '宫位': '戌宫',
        '签文': [
            '天地变通万物全，自营自养自安然。',
            '生罗万象皆精彩，事事如心谢圣贤。'
        ],
        '签意': '此卦大地交泰之象。凡事大吉无危也。',
        '签解': '天生万物。谋望皆通。福德相助。瑞气匆匆。'
    },
    {
        '签数': 44,
        '签名': '姜维邓艾斗阵',
        '吉凶': '中签',
        '宫位': '戌宫',
        '签文': [
            '棋逢敌手着相宜，黑白盘中未决时。',
            '皆因一着知胜败，须教自有好推宜。'
        ],
        '签意': '此卦棋逢敌手之象。凡事用机关则吉也。',
        '签解': '欲求心事。恰如围棋。到底胜利。宜用心机。'
    },
    {
        '签数': 45,
        '签名': '仁宗遇仙',
        '吉凶': '上签',
        '宫位': '戌宫',
        '签文': [
            '温柔自古胜刚强，积善之门大吉昌。',
            '若是有人占此卦，宛如正渴遇琼浆。'
        ],
        '签意': '此卦积善温柔之象。凡事贵人和合也。',
        '签解': '天地有感。应验非常。佛神护佑。得之莫忘。'
    },
    {
        '签数': 46,
        '签名': '渭水钓鱼',
        '吉凶': '中签',
        '宫位': '戌宫',
        '签文': [
            '劝君耐守旧生涯，把定心肠勿起歹。',
            '直待有人轻着力，枯枝老树再生花。'
        ],
        '签意': '此卦枯木生花之象。凡事自有成就也。',
        '签解': '守旧守旧。事自成就。动则多殃。静则无咎。'
    },
    {
        '签数': 47,
        '签名': '梁灏登科',
        '吉凶': '上签',
        '宫位': '亥宫',
        '签文': [
            '锦上添花色愈鲜，运来禄马喜双全。',
            '时人莫恨功名晚，一举登科四海传。'
        ],
        '签意': '此卦锦上添花之象。凡事大吉大利也。',
        '签解': '守旧变新。运至功成。遂平生志。尽皆是命。'
    },
    {
        '签数': 48,
        '签名': '韩信挂帅',
        '吉凶': '中签',
        '宫位': '亥宫',
        '签文': [
            '昆鸟秋来化作鹏，好游快乐喜飞腾。',
            '翱翔万里云霄去，余外诸禽总不能。'
        ],
        '签意': '此卦昆鹏兴变之象。凡事有变动大吉。',
        '签解': '昆鸟化鹏。万禽不能。桂香一折。福禄自增。'
    },
    {
        '签数': 49,
        '签名': '王祥求鲤',
        '吉凶': '中签',
        '宫位': '亥宫',
        '签文': [
            '鲲鸟秋来化作鹏，好游快乐喜飞腾。',
            '翱翔万里云霄去，余外诸禽总不能。'
        ],
        '签意': '此卦水结成冰之象。凡事不用枉求也。',
        '签解': '水结成冰。冰消成水。若是营谋。到底如是。'
    },
    {
        '签数': 50,
        '签名': '陶朱归五湖',
        '吉凶': '亥宫',
        '宫位': '申宫',
        '签文': [
            '五湖四海任君行，高挂帆蓬自在撑。',
            '若得顺风随即至，满船宝贝喜层层。'
        ],
        '签意': '此卦顺风撑船之象。凡事皆顺大吉也。',
        '签解': '自在休悠。不须着力。财禄重重。无不欣美。'
    },
    {
        '签数': 51,
        '签名': '孔明入川',
        '吉凶': '上签',
        '宫位': '子宫',
        '签文': [
            '夏日炎天日最长，人人愁热闷非常。',
            '天地也解知人意，熏风拂拂自然凉。'
        ],
        '签意': '此卦人人愁热之象。凡事随心从意也。',
        '签解': '进退莫疑。自有佳期。营谋用度。不须妄为。'
    },
    {
        '签数': 52,
        '签名': '太白醉捞明月',
        '吉凶': '中签',
        '宫位': '子宫',
        '签文': [
            '水中捞月费功夫，费尽功夫却又无。',
            '莫说闲言并乱语，枉劳心力强身孤。'
        ],
        '签意': '此卦贪求费力之象。凡事劳心费力也。',
        '签解': '言语难思。费力劳心。宅中忧恼。待遇贵人。'
    },
    {
        '签数': 53,
        '签名': '刘备招亲',
        '吉凶': '中签',
        '宫位': '子宫',
        '签文': [
            '失意反成得意时，龙呤虎啸两相宜。',
            '青天自有通霄路，许我功名再有期。'
        ],
        '签意': '此卦龙吟虎啸之象。凡事顺意有望也。',
        '签解': '教去即去。教住即住。自有亨通。到头必利。'
    },
    {
        '签数': 54,
        '签名': '马超追曹',
        '吉凶': '下签',
        '宫位': '子宫',
        '签文': [
            '梦中得宝醒来无，自谓南山只是锄。',
            '若问婚姻并问病，别寻条路为相扶。'
        ],
        '签意': '此卦梦中得宝之象。凡事枉费心力也。',
        '签解': '物在水中。形影长短。皆有分定。不用商量。'
    },
    {
        '签数': 55,
        '签名': '周武王登位',
        '吉凶': '中签',
        '宫位': '丑宫',
        '签文': [
            '父贤传子子传孙，衣食丰隆只靠天。',
            '堂上椿萱人快乐，饥饭渴饮困时眠。'
        ],
        '签意': '此卦接竹引泉之象。凡事谋望大吉也。',
        '签解': '接竹引泉。流传不绝。君子谋望。无不欣悦。'
    },
    {
        '签数': 56,
        '签名': '禄山谋反',
        '吉凶': '中签',
        '宫位': '丑宫',
        '签文': [
            '滩小石溪流水响，清风明月贵人忙。',
            '路须借问何方去，莫取林中花草香。'
        ],
        '签意': '此卦船行小滩之象。凡事有贵人助也。',
        '签解': '营谋用事。劳心费力。守旧待时。凡事大吉。'
    },
    {
        '签数': 57,
        '签名': '董仲寻亲',
        '吉凶': '中签',
        '宫位': '丑宫',
        '签文': [
            '说是说非风过耳，好衣好禄自然丰。',
            '君莫记取当年事，汝意还如我意同。'
        ],
        '签意': '此卦孩儿见母之象。诸事贵人大吉也。',
        '签解': '所用谋望。皆大欢喜。从公用力。如子逢娘。'
    },
    {
        '签数': 58,
        '签名': '文王问卜',
        '吉凶': '中签',
        '宫位': '丑宫',
        '签文': [
            '直言说话君须记，莫在他乡求别艺。',
            '切须守己旧生涯，除此其余都不利。'
        ],
        '签意': '此卦守旧待时之象。凡事守旧则吉也。',
        '签解': '得住且住。可取且踞。莫宜别事。只宜守旧。'
    },
    {
        '签数': 59,
        '签名': '张良隐山',
        '吉凶': '中签',
        '宫位': '寅宫',
        '签文': [
            '直上重楼去藏身，四围荆棘绕为林。',
            '天高君命长和短，得一反成失二人。'
        ],
        '签意': '此卦守旧随时之象。凡事待时则吉。',
        '签解': '如醉饮酒。只宜守旧。直待时来。无灾无咎。'
    },
    {
        '签数': 60,
        '签名': '赤壁鏖兵',
        '吉凶': '下签',
        '宫位': '寅宫',
        '签文': [
            '抱薪救火大皆燃，烧遍三千亦复然。',
            '若问荣华并出入，不如收拾枉劳心。'
        ],
        '签意': '此卦抱薪救火之象。凡事亦自谨防也。',
        '签解': '有千般计。不如莫动。一旦相惹。恐祸归身。'
    },
    {
        '签数': 61,
        '签名': '苏小妹难夫',
        '吉凶': '中签',
        '宫位': '寅宫',
        '签文': [
            '日上吟诗月下歌，逢场作戏笑呵呵。',
            '相逢会遇难藏避，唱彩齐唱连理罗。'
        ],
        '签意': '此卦守旧随时之象。凡事时吉利也。',
        '签解': '佳人在屋。吟唱诗曲。一片欢心。命中祸福。'
    },
    {
        '签数': 62,
        '签名': '唐僧得道',
        '吉凶': '中签',
        '宫位': '寅宫',
        '签文': [
            '晨昏全赖佛扶持，须是逢危却不危。',
            '若得贵人相引处，那时财帛亦相随。'
        ],
        '签意': '此卦神佛暗佑之象。凡事忍耐大吉也。',
        '签解': '平平稳稳。四方名显。改旧从新。亦无凶险。'
    },
    {
        '签数': 63,
        '签名': '女娲氏炼石',
        '吉凶': '中签',
        '宫位': '卯宫',
        '签文': [
            '昔然行船失了针，今朝依旧海中寻。',
            '若然寻得原针在，也费工夫也费心。'
        ],
        '签意': '此卦海中寻针之象。凡事费心劳力也。',
        '签解': '福是禄基。禄是福种。说得分明。切宜守谨。'
    },
    {
        '签数': 64,
        '签名': '马前覆水',
        '吉凶': '下签',
        '宫位': '卯宫',
        '签文': [
            '游鱼却在碧波池，撞遭罗网四边围。',
            '思量无计翻身出，事到头来惹事非。'
        ],
        '签意': '此卦鱼遭罗网之象。凡事亦宜提防也。',
        '签解': '屋下安身。祸从天降。早觉先防。免遭灾殃。'
    },
    {
        '签数': 65,
        '签名': '孙膑困庞涓',
        '吉凶': '下签',
        '宫位': '卯宫',
        '签文': [
            '眼前欢喜未为欢，亦不危时亦不安。',
            '割肉补疮为甚事，不如守旧待时光。'
        ],
        '签意': '此卦割肉成疮之象。凡事只宜守旧待时。',
        '签解': '知止则止。知宽自宽。割自身肉。疾痛一般。'
    },
    {
        '签数': 66,
        '签名': '霸王被困',
        '吉凶': '下签',
        '宫位': '卯宫',
        '签文': [
            '路险马乏人行急，失群军卒困相当。',
            '滩高风浪船棹破，日暮花残天降霜。'
        ],
        '签意': '此卦船破下滩之象。凡事险阻提防也。',
        '签解': '守旧待时。安静无咎。不用求谋。自在悠游。'
    },
    {
        '签数': 67,
        '签名': '金精试窦儿',
        '吉凶': '上签',
        '宫位': '卯宫',
        '签文': [
            '一条金线秤君心，无减无增无重轻。',
            '为人平生心正直，文章全具艺光明。'
        ],
        '签意': '此卦心平正直之象。凡事安稳无凶也。',
        '签解': '心平正直。到底清平。只依本份。天下太平。'
    },
    {
        '签数': 68,
        '签名': '郭汾阳祝寿',
        '吉凶': '中签',
        '宫位': '卯宫',
        '签文': [
            '门廷吉庆喜非常，积善之门大吉昌。',
            '婚姻田蚕诸事遂，病逢妙药即安康。'
        ],
        '签意': '此卦门廷吉庆之象。凡事顺遂也。',
        '签解': '积善之家。必有余庆。忠义之门。拱照福星。'
    },
    {
        '签数': 69,
        '签名': '梅开二度',
        '吉凶': '中签',
        '宫位': '辰宫',
        '签文': [
            '冬来岭上一枝梅，叶落枝枯终不摧。',
            '但得阳春悄急至，依然还我作花魁。'
        ],
        '签意': '此卦梅花占魁之象。凡事宜迟则吉也。',
        '签解': '一箭射空。当空不空。待等春来。彩在其中。'
    },
    {
        '签数': 70,
        '签名': '李密反唐',
        '吉凶': '下签',
        '宫位': '辰宫',
        '签文': [
            '朝朝恰似采花蜂，飞出西南又走东。',
            '春尽花残无觅处，此心不变旧行踪。'
        ],
        '签意': '此卦蜜蜂采花之象。凡事劳心费力也。',
        '签解': '无觅春色。久雨不晴。求谋用事。不如安静。'
    },
    {
        '签数': 71,
        '签名': '文君访相如',
        '吉凶': '中签',
        '宫位': '辰宫',
        '签文': [
            '认知苍龙下九衢，女子当年嫁二夫。',
            '自是一弓架两箭，欲恐龙马不安居。'
        ],
        '签意': '此卦一弓架两箭之象。凡事再合则吉也。',
        '签解': '不出重重。事由天命。振放中开。切宜谨守。'
    },
    {
        '签数': 72,
        '签名': '王莽求贤',
        '吉凶': '中签',
        '宫位': '辰宫',
        '签文': [
            '养蜂须用求他蜜，只怕遭触尾上针。',
            '须是眼前有异路，暗里深如荆棘林。'
        ],
        '签意': '此卦结蜂采蜜之象,诸事劳心费力。',
        '签解': '事须仔细。不用强求。结蜂采蜜。有甚来由。'
    },
    {
        '签数': 73,
        '签名': '陈桥兵变',
        '吉凶': '上签',
        '宫位': '巳宫',
        '签文': [
            '春来雷震百虫鸣，番身一转离泥中。',
            '始知出入还来往，一朝变化便成龙。'
        ],
        '签意': '此卦雷发百虫之象。凡事遇贵人吉兆也。',
        '签解': '雷发时转。出入两存。一朝变化。直到天门。'
    },
    {
        '签数': 74,
        '签名': '秦败擒三帅',
        '吉凶': '下签',
        '宫位': '巳宫',
        '签文': [
            '似鹄飞来自入笼，欲得番身却不通。',
            '南北东西都难出，此卦诚恐恨无穹。'
        ],
        '签意': '此卦似鹄投笼之象。凡事多虚少实也。',
        '签解': '进身不得。退步为难。低头直去。悉在其中。'
    },
    {
        '签数': 75,
        '签名': '伍员夜出昭关',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '恰如抱虎过高山，战战竞竞胆碎寒。',
            '不觉忽然从好事，切须保守一身安。'
        ],
        '签意': '此卦抱虎过山之象。凡事险凶惊恐也。',
        '签解': '危危险险。前程有阻。若问求谋。到底辛苦。'
    },
    {
        '签数': 76,
        '签名': '洪武看牛',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '鱼龙混杂意相同，耐守深潭待运通。',
            '不觉一朝头耸出，禹门一跳过龙宫。'
        ],
        '签意': '此卦鱼龙未变之象。凡事待时至可也。',
        '签解': '虽是滋基。也要待时。营谋自本。切莫妄为。'
    },
    {
        '签数': 77,
        '签名': '捧璧归赵',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '梦中说得是多财，声名云外总虚来。',
            '水远山遥难信实，贵人指点笑颜开。'
        ],
        '签意': '此卦梦中得宝之象。凡事虚多少实也。',
        '签解': '如梦说梦。声名莫望。只待好时。贵人指示。'
    },
    {
        '签数': 78,
        '签名': '临潼救驾',
        '吉凶': '上签',
        '宫位': '午宫',
        '签文': [
            '冷水未烧白涕汤，不寒不热有温凉。',
            '要行天下无他事，为有身中百艺强。'
        ],
        '签意': '此卦平善用事之象。凡事平稳大吉也。',
        '签解': '囚人逢赦。病遇良医。求财谋望。贵人指示。',
        '典故': '临潼救驾。隋末。唐王李渊经过临潼山下。秦琼(叔宝)正于伍员庙午睡。被喊声吵醒 秦琼冲进重围。杀退敌人。救了王爷一家。即被唐王重用。成为唐朝之开国功臣。'
    },
    {
        '签数': 79,
        '签名': '暗扶倒铜旗',
        '吉凶': '中签',
        '宫位': '午宫',
        '签文': [
            '虚空结愿保平安，保得身安愿不还。',
            '莫忘神圣宜还了，此知神语莫轻慢。'
        ],
        '签意': '此卦信实莫信虚之象。凡事守旧之兆也。',
        '签解': '人有我见。心不用忙。观音指示。切莫轻慢。',
        '典故': '隋末。东领关由杨义成镇守。并摆出铜旗阵。秦叔宝久攻不下。探知护阵主将罗成是他表弟。便联络姑母。命其子明保铜旗。暗助叔宝。秦叔宝破了铜旗阵。占领东岭关。得胜而归。',
    },
    {
        '签数': 80,
        '签名': '智远投军',
        '吉凶': '上签',
        '宫位': '未宫',
        '签文': [
            '直上仙岩要学仙，此知一旦帝王宣。',
            '青天日月常明照，心正声名四海传。'
        ],
        '签意': '此卦贵人接引之象。凡事和合大吉也。',
        '签解': '有始有终。莫向西东。心中用事。贵人重重。',
        '典故': '刘智远(知远)。沙陶(沙陀族)人。刘志远与妻李三娘居舅家。舅嫌其贫。哄志远往瓜园。欲给二瓜精吃掉。志远夜持鎗。战瓜精走入地。掘开见剑。拾之辞妻投军。投靠岳勋。官至安抚使。契丹灭晋。中原无主。智远于晋阳即帝位。改国曰后汉。仍称天福而不改元。'
    },
    {
        '签数': 81,
        '签名': '风送滕王阁',
        '吉凶': '上签',
        '宫位': '未宫',
        '签文': [
            '梧桐叶落秋将暮，行客归程去似云。',
            '谢得天公高着力，顺风船载宝珍归。'
        ],
        '签意': '此卦梧桐叶落之象。凡事先凶后吉也。',
        '签解': '心中取事。天必从之。营谋用事。尽可施为。',
        '典故': '唐朝咸淳年。南昌滕王阁重建成。王勃欲往。睡梦中水神曰送君一帆。醒来至江边。果见一船。上船后不久。即至滕王阁(离家七百里)。书滕王阁序。王勃乃唐高宗朝间一秀士。姓王名勃字子安。祖贯山西晋州龙门人氏。善诗。有颂曰：从来才子是神仙。风送南昌岂偶然。赋就滕王高阁句。便随仙仗伴中源。(中源指水神称中源水君。暗喻王勃成仙也)',
    },
    {
        '签数': 82,
        '签名': '火烧葫芦谷',
        '吉凶': '中签',
        '宫位': '未宫',
        '签文': [
            '炎炎烈火焰连天，焰里还生一朵莲。',
            '到底得成终不害，依然生叶长根枝。'
        ],
        '签意': '此卦火里生莲之象。凡事似险非险也。',
        '签解': '虽然逢险。不损其身。营谋用事。皆遇贵人。',
        '典故': '三国。赤壁之战曹操大败。落荒而逃。孔明派大将于各处埋伏。曹操至葫芦谷口休息。见地势险要又无伏兵而哈哈大笑。忽闻炮响。张飞杀到。山谷到处起火。曹操急上马。狼狈奔逃。败走华容道。',
    },
    {
        '签数': 83,
        '签名': '李渊登位',
        '吉凶': '中签',
        '宫位': '未宫',
        '签文': [
            '譬若初三四五缺，半无半有未圆全。',
            '等待十五良宵夜，到处光明到处圆。'
        ],
        '签意': '此卦月缺未圆之象，凡事候时则吉也。',
        '签解': '守旧待时。如月初出。待等圆时。无有不吉。',
        '典故': '公元六一八年。隋炀帝在江都看琼花。被部下杀死。唐王李渊得知。即于太原登基称帝。国号唐。李渊(唐高祖)在位九年。由李世民传(唐太宗)接位。喻境况渐入佳景。',
    },
    {
        '签数': 84,
        '签名': '庄子试妻',
        '吉凶': '下签',
        '宫位': '未宫',
        '签文': [
            '因名丧德如何事，切恐吉中变化凶。',
            '酒醉不知何处去，青松影里梦朦胧。'
        ],
        '签意': '此卦寒鱼离水招凶之象。凡事不可移动也。',
        '签解': '寒鱼离水。美中不足。若问营谋。不如莫起。',
        '典故': '周朝。姓庄名周。字子休。宋国蒙邑人。仕周为漆园吏。庄子假死试妻。其妻田氏守孝。七天后有一楚国王孙公子到访。自称庄子之徒。愿执百日之丧。田氏爱公子俊美。不足廿日成婚。公子叫心疼。曰脑髓(人心)可治。田氏往劈庄子棺以取脑髓(人心)。庄子破棺而出。后田氏羞愧自杀。',
    },
    {
        '签数': 85,
        '签名': '韩文公遇雪',
        '吉凶': '中签',
        '宫位': '申宫',
        '签文': [
            '云开雾罩山前路，万物圆中月再圆。',
            '若得诗书沉梦醒，贵人指引步天台。'
        ],
        '签意': '此卦春尽花开之象。凡事主后改变也。',
        '签解': '老者用求。春残再开。欲求名利。晚遇横财。',
        '典故': '韩愈。字退之。昌黎人。唐德宗贞元八年进士。谥文公。因谏迎佛骨。独怒天子。贬至潮州刺史。途经蓝关。大雪封山。马不向前。韩叹皇上不杀我。皇天亡我矣。事前其侄韩湘子曾曰：云横秦岭家何在。雪拥蓝关马不前。此时韩文公才悟其意。后韩愈弃官。财产尽捐地方。入山修道成仙。',
    },
    {
        '签数': 86,
        '签名': '商辂中三元',
        '吉凶': '上签',
        '宫位': '申宫',
        '签文': [
            '春来花发映阳台，万里车来进宝财。',
            '若得禹门三级浪，恰如平地一声雷。'
        ],
        '签意': '此卦上朝见帝之象。凡事大吉大利也。',
        '签解': '朝帝受职。如贫得宝。谋望从心。卦中第一。',
        '典故': '三元记。明朝。商辂。浙江人。父早亡。商辂三元及第。喻步步高升也。(三元即三级试。乡试：解元。省试：会元。殿试：状元。)',
    },
    {
        '签数': 87,
        '签名': '咬金探地穴',
        '吉凶': '中签',
        '宫位': '申宫',
        '签文': [
            '人行半岭日衔山，竣岭崖岩未可安。',
            '仰望上天为护佑，此身犹在太平间。'
        ],
        '签意': '此卦人处险境之象。凡事有贵人之兆也。',
        '签解': '凿石见玉。淘沙见金。须要着力。只是劳心。',
        '典故': '为庆战功。程咬金于演武杨摆宴。忽地裂一洞。深不可测。大家拈字抽签。咬金抽得。租绳缚身入穴。见石造之门桌椅桥等。桌上还有龙袍玉带。咬金穿着出洞。做了三年混世魔王。',
    },
    {
        '签数': 88,
        '签名': '庞洪畏包公',
        '吉凶': '中签',
        '宫位': '酉宫',
        '签文': [
            '木为一虎在当门，须是有威不害人。',
            '分明说是无防事，忧恼迟疑恐惊心。'
        ],
        '签意': '此卦木虎有威之象。凡事虚惊少实也。',
        '签解': '炉头点雪。似耳边风。可宜作福。后吉前凶。',
        '典故': '宋朝仁宗。包公为开封府府尹。庞洪为国丈(皇帝作女婿)。陷将军狄青于狱中。包公求审此案。庞洪惊畏万分。多方阻拦。后案情大白。证实庞洪诬陷。呈宋仁宗圣裁。又因皇戚被释。',
    },
    {
        '签数': 89,
        '签名': '智服姜维',
        '吉凶': '上签',
        '宫位': '酉宫',
        '签文': [
            '出入营谋大吉昌，似玉无瑕石里藏。',
            '若得贵人来指引，斯时得宝喜风光。'
        ],
        '签意': '此卦石藏珍宝之象。凡事称心大吉也。',
        '签解': '如石藏玉。贵人指示。得祗称心。欢怀得意。',
        '典故': '姜维字伯约。三国时魏大将。事母至孝。文武双全。智勇足备。诸葛亮极为爱惜。因此设计如何智取姜维归顺。诸葛亮一面派军攻打姜维母亲居住的冀城。引姜维出兵保护。一面派人在夜间假扮姜维投降蜀(刘备)攻打天水城。混乱魏军。使他们相信姜维已叛变。然后逼使姜维走投无路，下马向诸葛亮投降。诸葛亮下车迎接姜维。待之以礼。姜维也心悦诚服的归顺刘备了。',
    },
    {
        '签数': 90,
        '签名': '苇佩遇仙',
        '吉凶': '上签',
        '宫位': '酉宫',
        '签文': [
            '忽言一信向天飞，泰山宝贝满船归。',
            '若问路途成好事，前头仍有贵人推。'
        ],
        '签意': '此卦功名成就之象。凡事宜进大吉也。',
        '签解': '若问功名。前有贵人。更添喜气。财禄丰盈。',
        '典故': '穷书生韦佩年近四十。牵驴过洛阳桥。一渔夫卖大鳖。韦佩不忍。但缺钱。遂以驴换鳖。于桥下放生。从此韦佩中举。加官晋爵。或指此鳖为仙所化。故曰韦佩遇仙。',
    },
    {
        '签数': 91,
        '签名': '三战吕布',
        '吉凶': '中签',
        '宫位': '酉宫',
        '签文': [
            '好展愁眉出众来，前途改变喜多财。',
            '一条大路如天阔，凡有施财尽畅怀。'
        ],
        '签意': '此卦前途显达之象。凡事通泰大吉也。',
        '签解': '一条大路。可向前行。心中用事。只可向前。',
        '典故': '三国时。吕布领兵三万入驻虎牢关。张飞持三叉戟与吕布持丈八矛相战。不分胜负。关羽持青龙偃月刀加入。刘备又加入战圈。是为三英战吕布。吕布见不能胜。逃回关内。',
    },
    {
        '签数': 92,
        '签名': '蔡卿报恩',
        '吉凶': '上签',
        '宫位': '酉宫',
        '签文': [
            '自幼为商任设谋，财禄盈丰不用求。',
            '若是双身谋望事，秀才出去状元回。'
        ],
        '签意': '此卦自小为商之象。凡事勤俭无忧也。',
        '签解': '自小至大。无阻无碍。作意营谋。功名顺遂。',
        '典故': '蔡卿即蔡伯喈(蔡邕)。上京赴考。其妻赵五娘。因家贫以糟糠果腹。乡邻张广才时加接济。蔡伯喈中了状元。回家得知其妻获张广才相帮。夫妻便到张家拜谢。并赠银两。',
    },
    {
        '签数': 93,
        '签名': '高君保招亲',
        '吉凶': '中签',
        '宫位': '戌宫',
        '签文': [
            '鸾凤翔毛雨淋漓，当时却被雀儿欺。',
            '终教一日云开达，依旧还君整羽衣。'
        ],
        '签意': '此卦鸾凤被雨之象。凡事待时大利也。',
        '签解': '小人日盛。君子莫为。只宜守己。待时施为。',
        '典故': '高君保为高怀德之子。赵匡胤领兵征南唐被困。高君保领兵二百押粮接济。至双锁山。被女贼刘金定劫持。并强逼成亲。夫妻领众杀入重围。救出赵匡胤。',
    },
    {
        '签数': 94,
        '签名': '伯牙访友',
        '吉凶': '下签',
        '宫位': '戌宫',
        '签文': [
            '君子莫体小人为，事若差池各是非。',
            '琴鸣须用知音听，守常安静得依稀。'
        ],
        '签意': '此卦要逢知己之象。凡事守常则吉也。',
        '签解': '知音方许。闲事莫理。待得贵人。无不欢喜。',
        '典故': '春秋战国。姓俞名瑞字伯牙。楚国郢都人。事晋退休。乘船遇荒山。见樵夫子期欣赏其琴。遂结契兄弟。相约一年后重叙。到期再往访。才知钟子期已死。往访其坟。断弦碎琴。曰：摔碎瑶琴凤尾寒。子期不在对谁弹。春风满面皆朋友。欲觅知音难上难。',
    },
    {
        '签数': 95,
        '签名': '曹丕称帝',
        '吉凶': '中签',
        '宫位': '戌宫',
        '签文': [
            '志气功业在朝朝，今将酒色不胜饶。',
            '若见金鸡报君语，钱财福禄与君招。'
        ],
        '签意': '此卦志气功名之象。凡事守常大吉也。',
        '签解': '志气心动。守己未迟。金鸡报诺。无不欢喜。',
        '典故': '曹丕为曹操之次子。曹操挟天子(汉献帝)以令诸侯。曹丕废献帝自立。改国号为魏。七年后又被手下司马炎废掉。改国号为晋。',
    },
    {
        '签数': 96,
        '签名': '窦燕山积善',
        '吉凶': '上签',
        '宫位': '戌宫',
        '签文': [
            '巍峨宝塔不寻常，八面玲珑尽放光。',
            '劝君立志勤顶礼，作善苍天降福祥。'
        ],
        '签意': '此卦福德现身之象。凡事大吉大利也。',
        '签解': '这些福份。众人皆见。不用心忙。福德前定。',
        '典故': '宋朝。窦燕山中年无子。一夜梦中。其父训他去恶从善。自此窦燕山痛改前非。力行方便。并得五子。三字经有载：窦燕山。有义方。教五子。名俱扬。',
    },
    {
        '签数': 97,
        '签名': '六出祁山',
        '吉凶': '中签',
        '宫位': '亥宫',
        '签文': [
            '当风点烛空疏影，恍惚铺成镜里花。',
            '累被儿竟求牧拾，怎知只是幻浮槎。'
        ],
        '签意': '此卦当风点烛之象。凡事虚名不利也。',
        '签解': '富贵在天。贫穷是命。不用求谋。皆是前定。'
    },
    {
        '签数': 98,
        '签名': '吉平遇难',
        '吉凶': '下签',
        '宫位': '亥宫',
        '签文': [
            '出入求谋事宜迟，只恐闲愁惹是非。',
            '如鸟飞入罗网内，脱困能有几多时。'
        ],
        '签意': '此卦守旧随缘之象。凡事不如意主凶也。',
        '签解': '守旧随时。待贵人至。若问诸般。主事定迟。',
        '典故': '三国。医师吉平。感于曹操挟天子以令诸侯。欲杀奸臣。恰曹操头痛。吉平往治。药中下毒。曹操发觉。严刑拷打吉平。吉平大骂曹操。一头撞于石柱自杀。',
    },
    {
        '签数': 99,
        '签名': '陶三春挂帅',
        '吉凶': '下签',
        '宫位': '亥宫',
        '签文': [
            '勒马持鞭直过来，半有忧危半有灾。',
            '恰似遭火焚烧屋，天降时雨荡成灰。'
        ],
        '签意': '此卦半忧半喜之象。凡事只宜行善也。',
        '签解': '终身劳力。莫管是非。枷锁临时。怨尤自至。',
        '典故': '宋朝。陶洪之女。陶三春与郑恩比武成亲。生子郑印。娶妻王玉娥。皆习武。后闻郑恩与赵匡胤出兵南唐被围。陶三春带同子媳攻打南唐。两师会合。得胜而回。',
    },
    {
        '签数': 100,
        '签名': '三教谈道',
        '吉凶': '下签',
        '宫位': '亥宫',
        '签文': [
            '佛神灵通与君知，痴人说事转昏迷。',
            '老人求得灵签去，不如守旧待时来。'
        ],
        '签意': '此卦守常勿动之象。凡事宜待时吉也。',
        '签解': '此是满签。诸事不利。大作佛力。可保平安。',
        '典故': '北周武帝时。三教(儒释道)互相排斥。皇帝召集大会辩论。经过三次争辩。喻道在我教。理存我方。争执不止。没有结论。痴事一桩。后佛教成为中国人民信仰主流。也有三教同源之说。',
    }]

//关帝灵签
export const data3 = [
    {
        '签数': 1,
        '签名': '十八学士登瀛洲',
        '吉凶': '上上签',
        '宫位': '乾宫',
        '签文': [
            '巍巍独步向云间，玉殿千官第一班。',
            '富贵荣华天付汝，福如东海寿如山。'
        ],
        '签意': '此卦平步青云之象，诸事皆吉，福寿双全。',
        '签解': {
            '事业': '如平步青云，功成名就，有超越之喜。',
            '财运': '财运亨通，辛苦经营必有大利。',
            '婚姻': '美满和谐，天作之合，婚姻圆满。',
            '健康': '神灵庇佑，灾厄皆去，健康无虞。',
            '考试': '金榜题名，功名有望，名列前茅。',
            '出行': '出行顺利，步步小心，获利而归。',
            '其他': {
                '寻物': '遗落之物，月内可回。',
                '生活': '万事顺利，适合祈福、祭祀、求财等活动。'
            }
        },
        '提醒': '珍惜天赐良机，为人正直，必有大成。'
    },
    {
        '签数': 2,
        '签名': '韩蕲王西湖骑驴',
        '吉凶': '上吉',
        '宫位': '震宫',
        '签文': [
            '盈虚消息本天常，穷通得丧亦无妨。',
            '困极而亨谋遂意，前程归缩好修藏。'
        ],
        '签意': '此卦否极泰来之象，前运不佳，但此后渐入佳境，全在存心种德。',
        '签解': {
            '事业': '之前可能遇到挫折，但此后运势好转，适合积累德行，稳步发展。',
            '财运': '财运有起伏，但总体向好，需谨慎理财，不可贪心。',
            '婚姻': '感情逐渐好转，但需注重内在修养，珍惜缘分。',
            '健康': '健康状况好转，但需注意保持良好的生活习惯。',
            '考试': '成绩有望提升，但需努力，不可松懈。',
            '出行': '出行顺利，但需注意安全，保持谨慎。',
            '其他': {
                '寻物': '遗失物品可能难以找回，但不必过于担心。',
                '生活': '适合祈福、祭祀等活动，但需注重内心修养。'
            }
        },
        '提醒': '否极泰来，但需保持善念，积累德行，不可骄纵。'
    },
    {
        '签数': 3,
        '签名': '张公艺九世同居',
        '吉凶': '中吉',
        '宫位': '坤宫',
        '签文': [
            '衣食自然生处有，劝人安分守天常。',
            '孝悌忠信为根本，福禄来成祸不侵。'
        ],
        '签意': '此卦安分守己之象，凡事需循规蹈矩，不可强求。',
        '签解': {
            '事业': '适合守旧，不可贪求，循规蹈矩则吉。',
            '财运': '财运平稳，不可强求，安分守己则有利。',
            '婚姻': '婚姻稳定，需注重孝悌忠信，珍惜缘分。',
            '健康': '健康状况良好，但需保持良好生活习惯。',
            '考试': '考试成绩尚可，但需努力，不可松懈。',
            '出行': '出行顺利，但需注意安全，保持谨慎。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '适合祈福、祭祀等活动，但需注重内心修养。'
            }
        },
        '提醒': '安分守己，注重孝悌忠信，不可强求。'
    },
    {
        '签数': 4,
        '签名': '张翰忆鲈鱼',
        '吉凶': '下下签',
        '宫位': '离宫',
        '签文': [
            '去年相宜已往吉，今年运衰见在凶。',
            '瓣香告神早修省，转祸为福保无凶。'
        ],
        '签意': '此卦运衰之象，需诚心祈求神明庇佑，转祸为福。',
        '签解': {
            '事业': '运势不佳，需谨慎行事，不可强求。',
            '财运': '财运衰败，需谨慎理财，不可盲目投资。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '诚心祈求神明庇佑，转祸为福，不可强求。'
    },
    {
        '签数': 5,
        '签名': '吕蒙正守困',
        '吉凶': '中平签',
        '宫位': '坎宫',
        '签文': [
            '三般句意两游移，秋景冷落事难期。',
            '子丑交承春日到，更新气象百事宜。'
        ],
        '签意': '此卦先忧后喜之象，需耐心等待时机，终有转机。',
        '签解': {
            '事业': '当前运势不佳，需耐心等待时机，终有转机。',
            '财运': '财运不佳，需谨慎理财，不可盲目投资。',
            '婚姻': '婚姻关系需谨慎处理，等待时机成熟。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需耐心等待。'
            }
        },
        '提醒': '耐心等待时机，终有转机，不可急躁。'
    },
    {
        '签数': 6,
        '签名': '相如完璧归赵',
        '吉凶': '下下签',
        '宫位': '艮宫',
        '签文': [
            '鼓瑟吹笙宴嘉宾，寸步万里难知心。',
            '休将私意系浓情，彼此怀疑祸将临。'
        ],
        '签意': '此卦疑虑重重之象，需谨慎行事，避免陷入困境。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，避免与人产生怀疑。',
            '财运': '财运不佳，需谨慎理财，不可盲目投资。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '谨慎行事，避免与人产生怀疑，不可冲动。'
    },
    {
        '签数': 7,
        '签名': '吕洞宾炼丹',
        '吉凶': '大吉',
        '宫位': '乾宫',
        '签文': [
            '道骨天生仙有路，指日丹成冲云霄。',
            '引领向天身在上，凡骨成仙福寿高。'
        ],
        '签意': '此卦大吉之象，凡事皆吉，但需谨慎行事。',
        '签解': {
            '事业': '贵人相助，有飞腾之兆。',
            '财运': '财运亨通，投资有成。',
            '婚姻': '婚姻美满，百年偕老。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '珍惜天赐良机，不可强求。'
    },
    {
        '签数': 8,
        '签名': '伊尹耕莘乐道',
        '吉凶': '上上签',
        '宫位': '震宫',
        '签文': [
            '耕稼无收指往事，今岁有秋指现在。',
            '太平日里优游乐，百无忧愁事事成。'
        ],
        '签意': '此卦否极泰来之象，前运不佳，但此后渐入佳境。',
        '签解': {
            '事业': '事业顺利，渐有收获。',
            '财运': '财运渐好，不可强求。',
            '婚姻': '婚姻稳定，需耐心等待。',
            '健康': '健康状况良好，但需保持良好生活习惯。',
            '考试': '考试成绩尚可，但需努力。',
            '出行': '出行顺利，但需注意安全。',
            '其他': {
                '寻物': '遗失物品可能找回。',
                '生活': '适合祈福、祭祀等活动，但需耐心等待。'
            }
        },
        '提醒': '安分守己，不可强求。'
    },
    {
        '签数': 9,
        '签名': '张京兆画眉',
        '吉凶': '大吉',
        '宫位': '坤宫',
        '签文': [
            '望消息久盼望，仔细看镜自照。',
            '文书入境消息到，喜色眉端事事成。'
        ],
        '签意': '此卦大吉之象，凡事皆吉，但需谨慎行事。',
        '签解': {
            '事业': '事业顺利，有好消息。',
            '财运': '财运亨通，投资有成。',
            '婚姻': '婚姻美满，百年偕老。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '珍惜天赐良机，不可强求。'
    },
    {
        '签数': 10,
        '签名': '孟郊五十登第',
        '吉凶': '下下签',
        '宫位': '离宫',
        '签文': [
            '运途蹇衰欠吉，卜筮何益。',
            '及早种福，冬至后有变。'
        ],
        '签意': '此卦运衰之象，需诚心祈求神明庇佑，转祸为福。',
        '签解': {
            '事业': '运势不佳，需谨慎行事。',
            '财运': '财运衰败，需谨慎理财。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全。',
            '其他': {
                '寻物': '遗失物品难以找回。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '诚心祈求神明庇佑，转祸为福。'
    },
    {
        '签数': 11,
        '签名': '孙膑遇庞涓',
        '吉凶': '下下签',
        '宫位': '坎宫',
        '签文': [
            '一番新初势得意，萃汝身外似光彩。',
            '翻云覆雨难测，独立伤神慎行事。'
        ],
        '签意': '此卦先吉后凶之象，需谨慎行事。',
        '签解': {
            '事业': '事业受阻，需谨慎行事。',
            '财运': '财运不佳，需谨慎理财。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全。',
            '其他': {
                '寻物': '遗失物品难以找回。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '谨慎行事，不可强求。'
    },
    {
        '签数': 12,
        '签名': '鲍叔牙荐管仲',
        '吉凶': '中平签',
        '宫位': '艮宫',
        '签文': [
            '春后期望秋不然，主谋为反复。',
            '清江公子真知己，保安全一生丰。'
        ],
        '签意': '此卦安分守己之象，凡事需循规蹈矩，不可强求。',
        '签解': {
            '事业': '适合守旧，不可贪求，循规蹈矩则吉。',
            '财运': '财运平稳，不可强求，安分守己则有利。',
            '婚姻': '婚姻稳定，需注重孝悌忠信，珍惜缘分。',
            '健康': '健康状况良好，但需保持良好生活习惯。',
            '考试': '考试成绩尚可，但需努力，不可松懈。',
            '出行': '出行顺利，但需注意安全，保持谨慎。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '适合祈福、祭祀等活动，但需注重内心修养。'
            }
        },
        '提醒': '安分守己，注重孝悌忠信，不可强求。'
    },
    {
        '签数': 13,
        '签名': '姜太公钓蟠溪',
        '吉凶': '上吉',
        '宫位': '兑宫',
        '签文': [
            '江头钧翁安闲守，沉困时须宜学此。',
            '玉兔重生逢卯日，万人头上逞英雄。'
        ],
        '签意': '此卦上吉之象，需耐心等待时机。',
        '签解': {
            '事业': '事业顺利，有望获得贵人相助。',
            '财运': '财运亨通，投资有成，但需谨慎。',
            '婚姻': '婚姻美满，百年偕老，但需珍惜缘分。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '耐心等待时机，不可急躁。'
    },
    {
        '签数': 14,
        '签名': '张耳陈余交',
        '吉凶': '下下签',
        '宫位': '坎宫',
        '签文': [
            '佳人一见便喜欢，去后多般情意反。',
            '人情冷暖世常有，慎勿轻信免祸端。'
        ],
        '签意': '此卦先喜后忧，人情反复，需谨慎行事。',
        '签解': {
            '事业': '初期顺利，但后续可能遇阻，需小心提防小人。',
            '财运': '财运不佳，投资需谨慎，避免盲目信任他人。',
            '婚姻': '感情易反复，需慎重对待，避免冲动。',
            '健康': '健康状况需注意，避免因情绪波动影响健康。',
            '考试': '考试成绩不理想，需努力用功，不可轻敌。',
            '出行': '出行需谨慎，注意安全，避免与人争执。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '慎勿轻信他人，凡事需谨慎，避免冲动。'
    },
    {
        '签数': 15,
        '签名': '王羲之坦腹',
        '吉凶': '中平签',
        '宫位': '坤宫',
        '签文': [
            '看似机缘终反复，强求无益反生忧。',
            '待时而动春消息，佳偶天成不用愁。'
        ],
        '签意': '此卦机缘未到，需耐心等待时机。',
        '签解': {
            '事业': '当前不宜强求，需耐心等待时机。',
            '财运': '财运平稳，但需谨慎理财，不可强求。',
            '婚姻': '婚姻不宜强求，待时而动，自然有好结果。',
            '健康': '健康状况良好，但需保持良好生活习惯。',
            '考试': '考试成绩尚可，但需努力，不可松懈。',
            '出行': '出行顺利，但需注意安全，保持谨慎。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '适合祈福、祭祀等活动，但需耐心等待。'
            }
        },
        '提醒': '耐心等待时机，不可强求。'
    },
    {
        '签数': 16,
        '签名': '田氏紫荆再荣',
        '吉凶': '下下签',
        '宫位': '离宫',
        '签文': [
            '是非未决慎前行，和为贵处事方宁。',
            '骨肉商谋共进退，全身而退保太平。'
        ],
        '签意': '此卦不利诉讼，需以和为贵，避免争执。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，避免争执。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '以和为贵，避免争执，不可强求。'
    },
    {
        '签数': 17,
        '签名': '虞芮争闲田',
        '吉凶': '下下签',
        '宫位': '坎宫',
        '签文': [
            '凡事依本分，公平是正途。',
            '机关虽得胜，子孙受祸殃。'
        ],
        '签意': '此卦不利争讼，需依本分行事，不可强求。',
        '签解': {
            '事业': '事业不宜强求，需依本分行事，不可投机取巧。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '依本分行事，不可强求，避免争讼。'
    },
    {
        '签数': 18,
        '签名': '王佑植三槐',
        '吉凶': '中平签',
        '宫位': '坤宫',
        '签文': [
            '空华水月皆虚幻，脚踏实地是正途。',
            '善念善行多积累，自然福报在前头。'
        ],
        '签意': '此卦虚幻不实，需脚踏实地，多行善事。',
        '签解': {
            '事业': '事业需脚踏实地，不可好高骛远。',
            '财运': '财运平稳，但需谨慎理财，不可强求。',
            '婚姻': '婚姻稳定，需注重孝悌忠信，珍惜缘分。',
            '健康': '健康状况良好，但需保持良好生活习惯。',
            '考试': '考试成绩尚可，但需努力，不可松懈。',
            '出行': '出行顺利，但需注意安全，保持谨慎。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '适合祈福、祭祀等活动，但需注重内心修养。'
            }
        },
        '提醒': '脚踏实地，多行善事，不可强求。'
    },
    {
        '签数': 19,
        '签名': '裴航遇仙',
        '吉凶': '上吉',
        '宫位': '乾宫',
        '签文': [
            '久困沈埋今始泰，作事有成百事宜。',
            '名利双收人共羡，婚姻美满喜盈门。'
        ],
        '签意': '此卦大吉之象，凡事皆吉，百事如意。',
        '签解': {
            '事业': '事业顺利，名利双收，有贵人相助。',
            '财运': '财运亨通，投资有成，但需谨慎。',
            '婚姻': '婚姻美满，百年偕老，但需珍惜缘分。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '珍惜天赐良机，不可强求。'
    },
    {
        '签数': 20,
        '签名': '严子陵登钓台',
        '吉凶': '下下签',
        '宫位': '离宫',
        '签文': [
            '险难在前慎提防，流水浮云皆幻象。',
            '达观排遣心自宽，困而得亨终有望。'
        ],
        '签意': '此卦险难在前，需谨慎行事，不可强求。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，避免争执。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '谨慎行事，不可强求，避免争执。'
    },
    {
        '签数': 21,
        '签名': '须贾害范睢',
        '吉凶': '下下签',
        '宫位': '坎宫',
        '签文': [
            '夙昔结成冤，相逢显恶缘。',
            '经文讽诵多行善，化解冤仇保平安。'
        ],
        '签意': '此卦冤仇缠结，需回心向善，化解冤仇。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，避免争执。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '回心向善，化解冤仇，不可强求。'
    },
    {
        '签数': 22,
        '签名': '李泌七岁赋长歌',
        '吉凶': '上吉',
        '宫位': '震宫',
        '签文': [
            '池开白莲出污泥，高贵清严自天成。',
            '但恐花无久艳意，功名利禄皆浮名。'
        ],
        '签意': '此卦清高之象，功名利禄皆浮名，需淡泊名利。',
        '签解': {
            '事业': '事业顺利，但需淡泊名利，不可强求。',
            '财运': '财运亨通，但需谨慎理财，不可强求。',
            '婚姻': '婚姻美满，百年偕老，但需珍惜缘分。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '淡泊名利，不可强求。'
    },
    {
        '签数': 23,
        '签名': '殷浩书空',
        '吉凶': '下下签',
        '宫位': '坤宫',
        '签文': [
            '花开花谢荣悴常，运程更变难久长。',
            '万事成空终无望，退谢守分保安康。'
        ],
        '签意': '此卦运势无常，荣华富贵皆成空，需退谢守分。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，不可强求。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '退谢守分，不可强求。'
    },
    {
        '签数': 24,
        '签名': '端木结驷连骑',
        '吉凶': '中吉',
        '宫位': '离宫',
        '签文': [
            '先难后易事终成，春夏秋冬各有期。',
            '名利双收需待时，坚持到底必有成。'
        ],
        '签意': '此卦先难后易，名利双收需待时。',
        '签解': {
            '事业': '事业开始艰难，但坚持到底必有成。',
            '财运': '财运亨通，但需谨慎理财，不可强求。',
            '婚姻': '婚姻美满，百年偕老，但需珍惜缘分。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '坚持到底，不可强求。'
    },
    {
        '签数': 25,
        '签名': '芙蓉镜下及第',
        '吉凶': '中平签',
        '宫位': '乾宫',
        '签文': [
            '春夏秋时事迟疑，直待三冬方亨通。',
            '卯酉月日枯木花，后福未可量。'
        ],
        '签意': '此卦先蹇后泰，枯木逢春，后福不浅。',
        '签解': {
            '事业': '事业开始艰难，但坚持到底必有成。',
            '财运': '财运亨通，但需谨慎理财，不可强求。',
            '婚姻': '婚姻美满，百年偕老，但需珍惜缘分。',
            '健康': '健康状况良好，但需注意保养。',
            '考试': '考试成绩理想，名列前茅。',
            '出行': '出行顺利，有贵人相助。',
            '其他': {
                '寻物': '遗失物品可能找回，但需及时寻找。',
                '生活': '万事顺利，适合祈福、祭祀等活动。'
            }
        },
        '提醒': '坚持到底，不可强求。'
    },
    {
        '签数': 26,
        '签名': '邵尧夫告天',
        '吉凶': '中吉',
        '宫位': '坤宫',
        '签文': [
            '吉凶天数皆有定，且待时来福气和。',
            '祈祷三日内必应，营为好事入门多。'
        ],
        '签意': '此卦吉凶天定，需等待时机，不可强求。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，不可强求。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '等待时机，不可强求。'
    },
    {
        '签数': 27,
        '签名': '项仲山饮马投钱',
        '吉凶': '中平签',
        '宫位': '坎宫',
        '签文': [
            '名利近不可得，久后自有成就。',
            '一毫莫取，戒勿为贪心妄求之事。'
        ],
        '签意': '此卦名利需待时，不可妄求。',
        '签解': {
            '事业': '事业受阻，需谨慎行事，不可强求。',
            '财运': '财运不佳，需谨慎理财，不可强求。',
            '婚姻': '婚姻关系需谨慎处理，避免冲动。',
            '健康': '健康状况不佳，需注意保养，及时就医。',
            '考试': '考试成绩不理想，需努力用功。',
            '出行': '出行需谨慎，注意安全，避免意外。',
            '其他': {
                '寻物': '遗失物品难以找回，需注意保管。',
                '生活': '适合祈福、祭祀等活动，但需谨慎行事。'
            }
        },
        '提醒': '安分守己，不可妄求。'
    },
    {
        '签数': '28',
        '签名': '丙辛 (上吉) 司马题桥',
        '吉凶': '上吉',
        '宫位': '未知',
        '签文': [
            '病与讼、久方解、名与利、姑少待、若失物、寻必在、虽暂困、终必泰。',
            '此签吉利。凡事切莫堕志。更须修心向善。自有好处。问讼久方决。名利稍迟。失物可寻。病宜作福禳解。行人久后必至。'
        ],
        '签意': '人世间的功名利禄，只要辛勤努力，必能达到。',
        '签解': {
            '事业': '目前虽有困难，但只要坚持努力，终将有成就。',
            '财运': '财运稍迟，但终会好转，需耐心等待。',
            '婚姻': '婚姻之事需耐心等待，不可急躁。',
            '健康': '疾病可治愈，需作福禳解。',
            '考试': '名利稍迟，考试成绩或需时间等待。',
            '出行': '出行之人久后必至，耐心等待。',
            '其他': {
                '寻物': '失物可寻，不必过于担心。'
            }
        },
        '提醒': '勤苦可得，勿堕志，修心向善。'
    },
    {
        '签数': '29',
        '签名': '丙壬 (上吉) 王孝先还妄赠金',
        '吉凶': '上吉',
        '宫位': '未知',
        '签文': [
            '天福善、产贵子、病者安、讼得理、名必遂、仍得利、行人归、皆如意。',
            '此签士人占之大吉。官员占之高擢。庶人占之终有发达。但要修心积善。方得源远流长。'
        ],
        '签意': '吉运源自祖宗积德，珍惜并修持可得长久福运。',
        '签解': {
            '事业': '大吉之兆，事业将有显著提升。',
            '财运': '财运亨通，得名得利。',
            '婚姻': '婚姻如意，家庭和谐。',
            '健康': '疾病安康，无需忧虑。',
            '考试': '考试顺利，名列前茅。',
            '出行': '出行之人将如期归来。',
            '其他': {
                '生育': '将有贵子诞生。'
            }
        },
        '提醒': '修心积善，珍惜福运。'
    },
    {
        '签数': '30',
        '签名': '丙癸 (中吉) 柳毅传书',
        '吉凶': '中吉',
        '宫位': '未知',
        '签文': [
            '利虽有、莫妄作、讼宜和、病勿药、名待时、婚有约、但存心、安且乐。',
            '此签目下不宜妄取。只宜守己。官员占之。必有忧疑。若能谨守。自有佳音。'
        ],
        '签意': '目前不宜妄动，宜守己待时，未来自有佳音。',
        '签解': {
            '事业': '事业宜守不宜攻，静待时机。',
            '财运': '财运虽有，但不可妄取。',
            '婚姻': '婚姻有约，耐心等待佳音。',
            '健康': '疾病不宜依赖药物，宜调养身心。',
            '考试': '考试成绩需待时，不可急躁。',
            '出行': '出行之事宜谨慎考虑。',
            '其他': {
                '心态': '保持内心平静，安且乐。'
            }
        },
        '提醒': '守己待时，莫躁进。'
    },
    {
        '签数': '31',
        '签名': '丁甲 (中吉) 狄仁杰白云望亲',
        '吉凶': '中吉',
        '宫位': '未知',
        '签文': [
            '讼渐理、病渐康、财始达、名始彰、行人近、婚姻良、家道吉、福禄昌。',
            '此签秋冬平平。一切事宜。交春方有起色。'
        ],
        '签意': '秋冬平平，交春方有好运，诸事顺遂。',
        '签解': {
            '事业': '事业交春将有起色，耐心等待。',
            '财运': '财运始达，未来将有财富增长。',
            '婚姻': '婚姻良好，家庭和谐。',
            '健康': '疾病渐愈，身体将康复。',
            '考试': '考试成绩需待时，春天将有佳音。',
            '出行': '出行之人近期将至。',
            '其他': {
                '家道': '家道吉昌，福禄绵长。'
            }
        },
        '提醒': '秋冬平平，交春好运，耐心等待。'
    },
    {
        '签数': '32',
        '签名': '未知 (下下)',
        '吉凶': '下下',
        '宫位': '未知',
        '签文': [
            '讼终凶、名未通、病者险、财亦空、婚未合、是非丛。',
            '此签暗示诸事不顺，需谨慎行事。'
        ],
        '签意': '诸事不顺，需谨慎行事，避免争端。',
        '签解': {
            '事业': '事业受阻，需静待时机。',
            '财运': '财运不佳，需节约开支。',
            '婚姻': '婚姻不合，需加强沟通。',
            '健康': '病情严重，需及时就医。',
            '考试': '考试成绩不佳，需努力复习。',
            '出行': '出行不利，需推迟行程。',
            '其他': {}
        },
        '提醒': '诸事不顺，需谨慎行事，修身养性。'
    },
    {
        '签数': '33',
        '签名': '庄子慕道 (中吉)',
        '吉凶': '中吉',
        '宫位': '未知',
        '签文': [
            '功名富贵待时来，目下虽困渐渐开，若问婚姻并疾病，且待他年好运来。',
            '此签预示目前虽困顿但未来可期。'
        ],
        '签意': '目前虽困，但未来可期，诸事有望好转。',
        '签解': {
            '事业': '事业待时，未来将有起色。',
            '财运': '财运平平，未来有望增长。',
            '婚姻': '婚姻待时，缘分未到。',
            '健康': '疾病渐愈，需保持健康生活方式。',
            '考试': '考试成绩需待时，未来将有进步。',
            '出行': '出行需待时机，未来将有顺利行程。',
            '其他': {}
        },
        '提醒': '目前虽困，但未来可期，需耐心等待。'
    },
    {
        '签数': '34',
        '签名': '梅开二度 (大吉)',
        '吉凶': '大吉',
        '宫位': '未知',
        '签文': [
            '衰极转旺运刚来，犹如梅花二度开，婚姻求财多吉庆，口舌疾病俱无灾。',
            '此签象征衰极转旺，诸事大吉。'
        ],
        '签意': '衰极转旺，诸事大吉，婚姻和合，名利双收。',
        '签解': {
            '事业': '事业兴旺，名利双收。',
            '财运': '财运亨通，财富增长。',
            '婚姻': '婚姻和合，家庭幸福。',
            '健康': '身体健康，疾病远离。',
            '考试': '考试成绩优异，名列前茅。',
            '出行': '出行顺利，平安归来。',
            '其他': {}
        },
        '提醒': '衰极转旺，诸事大吉，需珍惜好运。'
    },
    {
        '签数': '35',
        '签名': '姜太公钓鱼 (大吉)',
        '吉凶': '大吉',
        '宫位': '未知',
        '签文': [
            '安乐自在吉星照，前程似锦任逍遥，婚姻求财多如意，口舌疾病俱消灭。',
            '此签预示安乐自在，诸事皆宜。'
        ],
        '签意': '安乐自在，诸事皆宜，婚姻和合，名利双收。',
        '签解': {
            '事业': '事业顺利，前程似锦。',
            '财运': '财运亨通，财源广进。',
            '婚姻': '婚姻美满，家庭和谐。',
            '健康': '身体健康，长命百岁。',
            '考试': '考试成绩优异，学业有成。',
            '出行': '出行平安，一帆风顺。',
            '其他': {}
        },
        '提醒': '安乐自在，诸事皆宜，需珍惜当下。'
    },
]